import moment from 'moment';
import { formatReleaseTime } from '@home/components/NavHeader/sreachContext/utils';
import { GRANULARITY_MOMENT_HELPER_MAPPING } from '@intelligence/utils/dateUtils';

import type { IDateTypely } from '@intelligence/types/common';

type IDateRangeWhenAlignDateModeFormatter = (
  locale: string,
  params?: {
    granularity?: string;
    start_release_time?: number;
    end_release_time?: number;
  },
  game?: {
    is_special_release_time?: boolean;
    release_time?: string;
    release_time_en?: string;
    release_time_cn?: string;
  },
) => string;

const formatDateRangeWhenAlignDateMode: IDateRangeWhenAlignDateModeFormatter = (locale, params, game) => {
  const isSpecialReleaseTime = !!game?.is_special_release_time;
  const releaseDateFormatted = formatReleaseTime(locale, {
    isSpecialReleaseTime,
    releaseTime: game?.release_time,
    releaseTimeEN: game?.release_time_en,
    releaseTimeCN: game?.release_time_cn,
  });
  if (!releaseDateFormatted) return '';
  if (isSpecialReleaseTime) return releaseDateFormatted;

  const releaseDateFormattedM = moment(releaseDateFormatted);
  if (!releaseDateFormattedM.isValid()) return releaseDateFormatted;

  const granularityOption =
    GRANULARITY_MOMENT_HELPER_MAPPING[params?.granularity as IDateTypely] ?? GRANULARITY_MOMENT_HELPER_MAPPING.daily;
  const granularityAmounts = granularityOption?.amounts as any;
  const granularityDateType = granularityOption?.dateType as any;
  const granularityFormat = granularityOption?.format;
  const startReleaseDate = releaseDateFormattedM
    .clone()
    .add(params?.start_release_time ?? 0, granularityAmounts)
    .startOf(granularityDateType)
    .format(granularityFormat);
  const endReleaseDate = releaseDateFormattedM
    .clone()
    .add(params?.end_release_time ?? 0, granularityAmounts)
    .endOf(granularityDateType)
    .format(granularityFormat);

  return `${startReleaseDate} ~ ${endReleaseDate}`;
};

export const formatDateRangeWhenAlignDateModePlus: IDateRangeWhenAlignDateModeFormatter = (...params) => {
  const originalCNLocaleData = moment.localeData('zh-cn');

  moment.updateLocale('zh-cn', {
    week: {
      dow: 0,
      doy: 4,
    },
  });

  const res = formatDateRangeWhenAlignDateMode(...params);

  // @ts-ignore
  if (originalCNLocaleData?._config?.week) {
    // @ts-ignore
    moment.updateLocale('zh-cn', { week: originalCNLocaleData?._config?.week });
  }

  return res;
};
